@if(loader){
<app-loader></app-loader>
}
<form [formGroup]="paymentTermsForm" >
    <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex justify-content-start">
            <p-button label="Save" icon="pi pi-save" size="small"
                (click)="createPaymentTerms(paymentTermsForm.value)"></p-button>
        </div>
        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
    </div>

    <div class="card flex justify-content-end mr-2">
        <p-checkbox formControlName="isActive" [binary]="true" inputId="binary" value="isActive" label="Active">
        </p-checkbox>
    </div>

    <div class="grid">
        <div class="col">
            <div class="field text-left">
                <label for="termsCode" class="label-required display">Payment Terms Code</label>
                <input pInputText placeholder="e.g: Payment Terms 20" formControlName="termsCode"
                    (keydown)="onKeydown($event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.termsCode.errors }"
                    class="w-full p-inputtext-sm" />
                <small *ngIf="submitted && formControls.termsCode.errors" id="termsCode-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left">
                <label for="discount" class="label-required display">Payment Discount %</label>
                <input pInputText type="number" placeholder="e.g: 20" formControlName="discount"
                    (keydown)="onKeydown($event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.discount.errors }"
                    class="w-full p-inputtext-sm" />
                <small *ngIf="submitted && formControls.discount.errors" id="discount-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left">
                <label for="conditionalDiscount" class="label-required display">Conditional Discount (Days)</label>
                <input pInputText type="number" placeholder="e.g: 25" formControlName="conditionalDiscount"
                    (keydown)="onKeydown($event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.conditionalDiscount.errors }"
                    class="p-inputtext-sm" style="width: 91%;" />
                <small *ngIf="submitted && formControls.conditionalDiscount.errors" id="conditionalDiscount-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left">
                <label for="netDue" class="label-required display">Net Due Days</label>
                <input pInputText type="number" placeholder="e.g: 30" formControlName="netDue"
                    (keydown)="onKeydown($event)"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.netDue.errors }" class="p-inputtext-sm"
                    style="width: 91%;" />
                <small *ngIf="submitted && formControls.netDue.errors" id="netDue-error" class="text-red-500">Required
                    field.</small>
            </div>
        </div>

        <div class="col">
            <div class="field text-left">
                <label for="paymentTermsDescription" class="label-required display">Payment Description</label>
                <textarea pInputText placeholder="e.g: Add your terms and conditions" style="height: 18rem;"
                    class="w-full p-inputtext-sm" formControlName="paymentTermsDescription"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.paymentTermsDescription.errors }"></textarea>
                <small *ngIf="submitted && formControls.paymentTermsDescription.errors"
                    id="paymentTermsDescription-error" class="text-red-500">Required field.</small>
            </div>
        </div>
    </div>
</form>

<p-toast></p-toast>